// @ts-nocheck
// @ts-ignore
//----------------------------- Set Cookie ----------------------------//
function setCookie(name, value, hrs) {
  let date = new Date();
  let hours;
  if (!hrs) hours = 24;
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

//------------------------check captcha cookie---------------------------//
function getCaptchaLoginCookie(name) {
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(name + "=") === 0) {
      return cookie.substring(name.length + 1, cookie.length);
    }
  }
  return null;
}

//---------------------- check existing cookie/ !cookie & login count >= 3 set cookie -----------------------//
function setandManageLoginCount() {
  const CaptchaCookieActive = getCaptchaLoginCookie("LoginCaptchaActivated");
  if (CaptchaCookieActive) {
    localStorage.removeItem("loginOtpCount");
    return true;
  }
  let loginCount = parseInt(localStorage.getItem("loginOtpCount")) || null;

  if (!loginCount) {
    localStorage.setItem("loginOtpCount", 1);
  } else if (loginCount && loginCount === 3) {
    setCookie("LoginCaptchaActivated", "true");
    delete localStorage.loginOtpCount;
    return true;
  }
  return loginCount;
}

//-------------------------- Generate Captcha Code ----------------------------//
function generateLoginModalCaptchaCode(target_element) {
  const loginCaptcha = document.getElementById("login-captcha-code");
  const OTPCaptcha = document.getElementById("otp_page-captcha-code");
  let uniquechar = "";
  const randomchar =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < 6; i++) {
    uniquechar += randomchar.charAt(
      Math.floor(Math.random() * randomchar.length)
    );
  }
  loginCaptcha.value = uniquechar;
  OTPCaptcha.value = uniquechar;
}

//---------------------------- Verify Captcha ---------------------------------//
function verifyLogincaptcha(target_element) {
  let captcha_code,
    user_captcha_inputValue,
    error_msg_holder,
    success_msg_holder;

  if (target_element) {
    captcha_code = target_element
      .closest("#captcha-code-snippet")
      .querySelector(".login-modal-captcha-code-text");
    user_captcha_inputValue = target_element.value;
    error_msg_holder = target_element
      .closest("#captcha-code-snippet")
      .querySelector(".login_modal_error_message");
    success_msg_holder = target_element
      .closest("#captcha-code-snippet")
      .querySelector(".login_modal_success_message");
  }

  if (user_captcha_inputValue && user_captcha_inputValue.length === 6) {
    //check value
    if (user_captcha_inputValue === captcha_code.value) {
      captcha_code.dataset.verified = true;
      showHide_errorSuccess(success_msg_holder, error_msg_holder, true);
    } else {
      captcha_code.dataset.verified = false;
      showHide_errorSuccess(success_msg_holder, error_msg_holder, false);
    }
  } else if (user_captcha_inputValue.length > 6) {
    target_element.value = target_element.value.slice(0, 6);
  } else {
    captcha_code.dataset.verified = false;
    hide_Error_and_Success_msg();
  }
  manageFormSubmitButton(
    captcha_code.id === "login-captcha-code" ? "login" : "otp"
  );
}

//====================== show/hide error/success message ============================//
function showHide_errorSuccess(
  success_msg_holder,
  error_msg_holder,
  showSuccess
) {
  if (showSuccess) {
    success_msg_holder.classList.remove("hidden");
    error_msg_holder.classList.add("hidden");
  } else {
    success_msg_holder.classList.add("hidden");
    error_msg_holder.classList.remove("hidden");
  }
}

// ======================== Reset Login Modal Captcha Code ==========================//
function resetLoginCaptchaCode() {
  const loginCaptchaHolder = document.querySelector(".login-captcha-container");
  const userLoginInput = document.getElementById("login-user-captcha-input");
  userLoginInput.value = "";
  loginCaptchaHolder.dataset.verified = false;
  hide_Error_and_Success_msg();
  generateLoginModalCaptchaCode();
}

// ======================== Reset OTP Modal Captcha Code ==========================//
function resetOTPCaptchaCode() {
  const OtpCaptchaHolder = document.querySelector(".otp_page-captcha-container");
  const userOTPcaptchaInput = document.getElementById("otp_page-user-captcha-input");
  userOTPcaptchaInput.value = "";
  OtpCaptchaHolder.dataset.verified = false;
  hide_Error_and_Success_msg();
  generateLoginModalCaptchaCode();
}

// ======================== Hide Captcha validation Error & Success msg ==========================//
function hide_Error_and_Success_msg() {
  document.getElementById("otp_page_error_message").classList.add("hidden");
  document.getElementById("otp_page_success_message").classList.add("hidden");
  document.getElementById("login_error_message").classList.add("hidden");
  document.getElementById("login_success_message").classList.add("hidden");
}

// ------------------- Manage Form Submit Validation when user captcha input is triggered ------------------------//
function manageFormSubmitButton(formTarget) {
  if (formTarget === "login") {
    manageLoginForm();
  } else {
    manageOTPForm();
  }
}

// ======================== Manage Login Form  ========================//
function manageLoginForm() {
  const phoneInput = document.querySelector("#modal .phone-entry input#mobile_code");
  phoneInput.dispatchEvent(new Event("input", { bubbles: true }));
}

// ======================== Manage OTP Form  ========================//
function manageOTPForm() {
  const OTPInputs = document.querySelectorAll(".otp-modal .verify-otp-input-form input.otp-input");
  OTPInputs[3].dispatchEvent(new Event("input", { bubbles: true }));
  manageResendOTPForm();
}

// ======================== manageResendOTP Button ========================//
function manageResendOTPForm() {
  const CaptchaCookieActive = getCaptchaLoginCookie("LoginCaptchaActivated");
  const resendOTPButton = document.querySelector(".otp-modal .resend-otp");
  const isCaptchaInputValidated = document.getElementById("otp_page-captcha-code").dataset.verified;
  if (CaptchaCookieActive && isCaptchaInputValidated === "true") {
    resendOTPButton.classList.remove("cursor-notallowed");
  } else if (!CaptchaCookieActive) {
    resendOTPButton.classList.remove("cursor-notallowed");
  } else {
    resendOTPButton.classList.add("cursor-notallowed");
  }
}

// ======================== check existing cookie/ !cookie & login count >= 3 set cookie  ========================//
function setandManageLoginCount() {
  const CaptchaCookieActive = getCaptchaLoginCookie("LoginCaptchaActivated");
  if (CaptchaCookieActive) {
    localStorage.removeItem("loginOtpCount");
    return true;
  }
  let loginCount = parseInt(localStorage.getItem("loginOtpCount")) || null;
  if (!loginCount) {
    localStorage.setItem("loginOtpCount", 1);
  } else if (loginCount && loginCount === 3) {
    setCookie("LoginCaptchaActivated", "true");
    delete localStorage.loginOtpCount;
    return true;
  }
  return loginCount;
}

// ======================== Show/Hide Captcha Validation Fields if captcha cookie is present  ========================//
function CaptchaFormVisibility() {
  const loginCaptchaForm = document.querySelector(".login-captcha-container");
  const OTPCaptchaForm = document.querySelector(".otp_page-captcha-container");
  const CaptchaCookieActive = getCaptchaLoginCookie("LoginCaptchaActivated");
  if (CaptchaCookieActive) {
    loginCaptchaForm.classList.remove("hidden");
    OTPCaptchaForm.classList.remove("hidden");
  } else {
    loginCaptchaForm.classList.add("hidden");
    OTPCaptchaForm.classList.add("hidden");
  }
}

// ======================== Reset OTP captcha Codes , Captcha user login Input values , manage login count & coookie , check captcha field visibility & Validations  ========================//
function aftersubmitChecks() {
  document.getElementById("otp_page-captcha-regenerate").click();
  document.getElementById("login-captcha-regenerate").click();
  resetLoginCaptchaCode();
  resetOTPCaptchaCode();
  setandManageLoginCount();
  CaptchaFormVisibility();
  verifyLogincaptcha(document.getElementById("otp_page-user-captcha-input"));
  verifyLogincaptcha(document.getElementById("login-user-captcha-input"));
}

// ================== on domload --> generateCaptcha & check captcha form visibility ==============================//
window.addEventListener("DOMContentLoaded", (x) => {
  if( getCaptchaLoginCookie("LoginCaptchaActivated") ) generateLoginModalCaptchaCode();
  CaptchaFormVisibility();
});

